import React from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import { OVERRIDE_ENTRY_CONFIG } from '../constants';
import { configuredMenuItemTransformer } from './utils';
import { cmsConfigTransformer } from './cmsConfigTransformer';

const cmsConfigurationTransformer = (props) => {
    const { useCmsConfig, config, cmsConfig, locale, theme, shouldPreRender, mode, rollouts } = props;

    return {
        useCmsConfig,
        config: configTransformer(
            cmsConfig ? cmsConfigTransformer(cmsConfig) : config,
            locale,
            mode
        ),
        locale,
        theme,
        shouldPreRender,
        mode,
        rollouts
    };
};

export const configTransformer = (config, locale, mode) => (
    Object.keys(config).reduce((levels, level) => ({
        ...levels,
        [level]: Object.keys(config[level]).reduce((res, itemId) => ({
            ...res,
            [itemId]: config[level][itemId].map((item) => {
                if (OVERRIDE_ENTRY_CONFIG.hasOwnProperty(itemId)) {
                    merge(item, OVERRIDE_ENTRY_CONFIG[itemId]);
                }
                return configuredMenuItemTransformer(item, locale, mode);
            })
        }), {})
    }), {})
);

export const withMenuTransformer = (WrappedComponent) => {

    const WithMenuTransformer = (props) => {
        const transformedProps = cmsConfigurationTransformer(props);

        return <WrappedComponent {...transformedProps}/>;
    };

    WithMenuTransformer.propTypes = {
        useCmsConfig: PropTypes.bool,
        config: PropTypes.object,
        cmsConfig: PropTypes.object,
        mode: PropTypes.string,
        theme: PropTypes.string,
        categoriesWithTitlesExp: PropTypes.bool,
        shouldPreRender: PropTypes.bool
    };

    WithMenuTransformer.defaultProps = {
        shouldPreRender: true
    };

    return WithMenuTransformer;
};
